import React from "react";
import { SectionKicker } from "@/components/shared/SectionBits";

export default function LegalPage({ title, kicker, body }) {
    return (
        <div data-testid={`legal-${title.toLowerCase().replace(/\s+/g, "-")}`} className="dr-container pt-32 pb-24">
            <SectionKicker>{kicker}</SectionKicker>
            <h1 className="font-display font-bold text-dr-navy text-5xl md:text-6xl leading-[1] max-w-3xl">{title}</h1>
            <div className="dr-prose mt-12 max-w-3xl">
                {body.split("\n\n").map((p, i) => <p key={i}>{p}</p>)}
            </div>
        </div>
    );
}
